var forge = require('node-forge')

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$forge', { value: forge })
  }
}
